import { setAdvertisingTrackingOptOut } from "@/api/orval/user/user";

import { adPixels } from "./adPixels";
import { getDeviceAdTrackingOptOut, setDeviceAdTrackingOptOut } from "./adTrackingOptOut";

/**
 * Brings the device choice and the signed-in patient's account choice together, opting out wins:
 * an account that opted out switches this device off, and a device that opted out while signed out
 * is saved to the account the patient then signs in to.
 */
export function syncAdTrackingOptOut(accountOptOut: boolean): void {
  if (accountOptOut) {
    setDeviceAdTrackingOptOut(true);
    adPixels.optOut();
    return;
  }
  if (getDeviceAdTrackingOptOut()) {
    void setAdvertisingTrackingOptOut({ optOut: true });
  }
}
